<button
    [type]="type"
    class="btn btn-{{variant}} col-12"
    [ngClass]="extraClasses"
    [disabled]="disabled"
    [attr.aria-label]="ariaLabel || null"
    (click)="onClick($event)">
    <i *ngIf="iconClass" [class]="iconClass" class="me-2"></i>
    <span *ngIf="!iconOnly">{{ label }}</span>
</button>
